module.exports = __webpack_public_path__ + "static/media/gallery-1-1.dd47b9a2.png";